/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-24 11:02:26
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-26 09:22:13
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\js\pew-select.js
 * @Description: 付费延保 - 自定义下拉选择框
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */

export class renderPEWSelect {
  constructor(elId = 'pew-select', data) {
    this.elId = elId;
    this.data = data;
    this.dom = this.initializeDom();
    this.placeholderText = '';
    this.init();
  }

  initializeDom() {
    return {
      $select: $(`#${this.elId}_wrapper`),
      $selected: null,
      $selectedText: null,
      $itemsContainer: null,
      $closeIcon: null,
      $subWrapper: null, // 新增子项盒子
      $subSelected: null, // 新增子项选择框
      $subItemsContainer: null, // 新增子项容器
      $subSelectedText: null, // 新增子项选中文本
      $hiddenInput: null,
    };
  }

  init() {
    this.dom.$selected = this.dom.$select.find('.select-selected');
    this.dom.$selectedText = this.dom.$selected.find('.selected-text');
    this.dom.$itemsContainer = this.dom.$select.find('.select-items');
    this.dom.$closeIcon = this.dom.$selected.find('.close-icon');

    this.dom.$subWrapper = this.dom.$select.find('.sub-wrapper');
    this.dom.$subSelected = this.dom.$select.find('.sub-selected');
    this.dom.$subSelectedText = this.dom.$select.find('.sub-selected .selected-text'); // 初始化子项选中文本
    this.dom.$subItemsContainer = this.dom.$select.find('.sub-items'); // 初始化子项容器

    this.dom.$hiddenInput = $(`#${this.elId}`);
    this.placeholderText = this.dom.$selectedText.data('text');

    this.render();
  }
  // 渲染下拉选择框
  render() {
    const that = this;

    // 初始化状态
    this.resetSelect('reset');

    // 动态插入数据项
    this.data.forEach((item) => {
      const $li = $('<li>').text(item.label).attr('data-type', item.type);
      if (Array.isArray(item.value)) {
        $li.attr('data-sub-options', JSON.stringify(item.value)).attr('data-value', '');
      } else {
        $li.attr('data-value', item.value);
      }
      $li.on('click', () => this.selectItem($li));

      this.dom.$itemsContainer.append($li);
    });

    // 绑定事件
    this.dom.$selected.off('click').on('click', this.toggleDropdown.bind(this));
    this.dom.$closeIcon.off('click').on('click', this.clearSelection.bind(this));
    this.dom.$subSelected.off('click').on('click', this.toggleSubDropdown.bind(this)); // 支持子下拉项点击重新下拉
    $(document).off(`click.${this.elId}`).on(`click.${this.elId}`, this.closeDropdown.bind(this));
  }

  // 切换父下拉菜单
  toggleDropdown() {
    const isOpen = this.dom.$itemsContainer.css('display') === 'block';
    this.dom.$itemsContainer.toggle(!isOpen);
    this.dom.$selected.toggleClass('open', !isOpen);
  }

  // 选择父项
  selectItem($li) {
    this.dom.$selectedText.text($li.text());
    this.dom.$itemsContainer.hide(); // 隐藏下拉菜单
    this.dom.$selected.removeClass('open').addClass('selected');
    this.dom.$closeIcon.show(); // 显示删除图标

    this.updateSelectedItem($li);

    // 更新隐藏域
    this.dom.$hiddenInput.val($li.data('value')).attr('data-type', $li.data('type'));
    this.dom.$hiddenInput.trigger('customValChange');

    // 如果有子列表，显示子列表项
    const subOptions = $li.data('sub-options');
    if (subOptions) {
      this.dom.$subWrapper.show(); // 显示子项盒子
      this.dom.$subItemsContainer.empty(); // 清空子项容器
      subOptions.forEach((subItem, index) => {
        const $subLi = $('<li>').text(subItem.label).attr('data-value', subItem.value).attr('data-type', subItem.type);
        $subLi.on('click', () => this.selectSubItem($subLi));
        this.dom.$subItemsContainer.append($subLi);

        // 默认选中第一个子项
        if (index === 0) {
          $subLi.trigger('click');
        }
      });
    } else {
      this.dom.$subWrapper.hide(); // 隐藏子项盒子
      this.dom.$subItemsContainer.hide(); // 隐藏子项容器
    }
  }

  // 切换子下拉菜单
  toggleSubDropdown() {
    const isOpen = this.dom.$subItemsContainer.css('display') === 'block';
    this.dom.$subItemsContainer.toggle(!isOpen);
    this.dom.$subSelected.toggleClass('open', !isOpen);
  }

  // 选择子项
  selectSubItem($subLi) {
    this.dom.$subSelectedText.text($subLi.text());
    this.dom.$subItemsContainer.hide(); // 隐藏子项容器
    this.dom.$subSelected.removeClass('open').addClass('selected');

    this.updateSelectedItem($subLi);

    // 更新隐藏域
    this.dom.$hiddenInput.val($subLi.data('value')).attr('data-type', $subLi.data('type'));
    this.dom.$hiddenInput.trigger('customValChange');
  }

  // 清除已选中项
  clearSelectedItem() {
    this.dom.$itemsContainer.find('li').removeClass('selected');
    this.dom.$subItemsContainer.find('li').removeClass('selected'); // 清除子项选中状态
  }

  // 重置选择框
  resetSelect(type) {
    this.dom.$selectedText.text(this.placeholderText);
    this.dom.$selected.removeClass('selected');
    this.dom.$closeIcon.hide(); // 隐藏删除图标

    this.dom.$subSelectedText.text(''); // 清空子项选中文本
    this.dom.$subSelected.removeClass('selected'); // 清除子项选中状态
    this.dom.$subItemsContainer.hide(); // 隐藏子项容器

    if (type === 'reset') {
      this.dom.$itemsContainer.hide()
      // 隐藏下拉菜单
      this.dom.$itemsContainer.empty();
    } else {
      this.clearSelectedItem(); // 清除下拉中已选中的状态
    }

    // 清除隐藏域
    this.dom.$hiddenInput.val('').removeAttr('data-type').trigger('customValChange');
  }

  // 清除已选中项
  clearSelection(e) {
    e.stopPropagation();
    this.resetSelect('clearSelected');
    this.dom.$itemsContainer.hide();
    this.dom.$selected.removeClass('open');

    this.dom.$subWrapper.hide();
    this.dom.$subSelected.removeClass('open');
  }

  // 关闭下拉菜单
  closeDropdown(e) {
    // 实现点击非目标元素，隐藏下拉菜单
    if (!$(e.target).closest(`#${this.elId}_wrapper`).length && !$(e.target).is(this.dom.$selected)) {
      this.dom.$itemsContainer.hide();
      this.dom.$selected.removeClass('open');
    }
  }

  // 更新已选中项
  updateSelectedItem($selectedItem) {
    this.clearSelectedItem();
    $selectedItem.addClass('selected');
  }

  // 销毁实例
  destroy() {
    $(document).off(`click.${this.elId}`);
    this.dom.$selected.off('click');
    this.dom.$closeIcon.off('click');
    this.dom.$itemsContainer.empty();

    this.dom.$subSelected.off('click');
    this.dom.$subItemsContainer.empty();
  }
}